import { createFileRoute, useNavigate } from '@tanstack/react-router'

import { PageBackButton } from '@/components/common/PageBackButton'
import { CustomerForm } from '@/components/forms/customer-form'
import { m } from '@/lib/paraglide/messages'

export const Route = createFileRoute('/_app/_authed/_sidebar/customers/new')({
    component: NewCustomerPage,
})

function NewCustomerPage() {
    const navigate = useNavigate()

    return (
        <div className="max-w-2xl space-y-4 page-pad">
            <div className="flex min-w-0 items-center gap-2">
                <PageBackButton className="-my-2 md:-my-1" />
                <h1 className="text-xl font-semibold">
                    {m.customer_add_new()}
                </h1>
            </div>
            <div className="rounded-md border p-6">
                <CustomerForm
                    onSuccess={() => void navigate({ to: '/customers' })}
                    onCancel={() => void navigate({ to: '/customers' })}
                />
            </div>
        </div>
    )
}
